<!-- Start: Rejwan: 08-05-2025 Batch Mailing Feature -->

<template>
    <div>
        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" :disabled="selected_settlements.length == 0" variant="primary" @click="addToList">Add for Batch Mailing</b-button>
        </div>

        <div v-if="custom_list.length>0">
            <common-list :checkbox="checkbox"  :pageurl="this.$api_url"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
        </div>
        <div v-else>

            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no employee to show.
            </div>
            
        </div>

        <b-modal id="bv-modal-preview-added-settlement" size="lg" dialog-class="w-1200"  hide-footer title="Preview Selected Settlement">
            <b-overlay  :show="showoverlaymodal" class='showoverlay_settle' rounded="sm">
                <table class="table dataTable">
                    <thead>
                        <tr class="table-head">
                            <th>Name</th>
                            <th>Employee Code</th>
                            <th>Settlement ID</th> 
                            <th>Settlement Type</th>
                            <th>Settlement Date</th>
                            <th>Settlement Amount</th>
                            <th>Status</th>
                            <th>Approval Pending</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
            
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="settle in added_settlements" :key="settle.settlement_id">
                            <td>{{ settle.name }}</td>
                            <td>{{ settle.employee_code }}</td>
                            <td>{{ settle.settlement_company_code }}</td>
                            <td>{{ settle.settlement_type }}</td>
                            <td>{{ settle.settle_date }}</td>
                            <td>{{ formatMoney(settle.settlement_amount) }}</td>
                            <td>{{settle.application_status}}</td>
                            <td>{{settle.approval_pending}}</td>
                            <td><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5" @click="deleteRow(settle.settlement_id)"></b-icon></td>
                        </tr>
                    </tbody>
                </table>

                <div class="col-12 mt-3 d-flex justify-content-center">
                    <div class="col-8 approve-level-content">            
                        <h3 class="text-center">Approvers of Level-{{approval_level}}</h3>
                        <div class="approve-level-inside-container clearfix"> 
                            <template v-for="(app,index) in global_approvers[approval_level]"> 
                                <template v-if=" selected[approval_level].includes(app.value)">
                                    <b-form-checkbox class="" v-model="primary_selected[approval_level]" :value="app.value" >{{app.text}}</b-form-checkbox>
                                </template>                               
                            </template>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <b-button class="text-center border rounded bg-light py-1 px-5 mt-4" variant="secondary" @click="submit()">Submit</b-button>
                </div>
            </b-overlay>
            
        </b-modal>

        <!-- Email Histoy of a particular settlement -->
        <b-modal id="bv-modal-preview-settlement-email-history" size="lg" dialog-class="w-1200"  hide-footer :title="'Email History of ' + selected_settlement_company_code">	
            <table class="table dataTable">
                <thead>
                    <tr class="table-head">
                        <th>Approver Name</th>
                        <th>Level</th>
                        <th>Sent Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="history in mail_history" :key="history.id">
                        <td>{{ history.approver_name }}</td>
                        <td>Level - {{ history.level }}</td>
                        <td>{{ history.sent_at }}</td>
                    </tr>
                    <tr v-if="mail_history.length === 0">
                        <td colspan="3" class="text-center">Nothing Found</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            
            this.showoverlaymodal = false;
        }, 
        props: ['flg','pageurl','is_action'],
        components: {
     
        },
        data(){            

            return {
                custom_list:[],  /* Data List */
                default_column:['name','employee_code'], /* Default Column List */
                appended_column:[
                     
                    { value: "settlement_company_code", text: "Settlement ID",type: "text"},
                    { value: "settlement_type", text: "Settlement Type",type: "text"},
                    { value: "settlement_date", text: "Settlement Date",type: "date"}, 
                    // { value: "settlement_amount", text: "Settlement Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "settlement_amount", text: "Settlement Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "application_status", text: "Status",type: "text"},
                    { value: "approval_pending", text: "Approval Pending",type: "text"},
                
                    
                ],                   /* Appended Column List  and there title and type */
                primary_key:'settlement_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */
                list_key:0,
                is_n_pf:1,
                show_loader:false,
                settlement_id:0,
                settle_form_key:0,
                employee_id:0,
                employee_name:0,
                show_approval:0,
                quick_view :0,
                action_type:"",
                checkbox:1,
                selected_settlements : [],
                added_settlements: [],
                approval_level: null,
                added_settlement_ids: [],

                // Approval Related Works
                approvers_depth : 0,
                global_approvers : {},
                level_details : [],
                selected : [],
                primary_selected : [],
                mail_history: [],
                selected_settlement_company_code: null,
                showoverlaymodal: false,
            }
        },
        methods:{
            listReturn:function(data)
            {
                this.selected_settlements = data.selected;

                if(data.action_id==1)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id); 
                    if(data.settlement_id > 0)
                    {
                        this.mail_history = [];
                        this.selected_settlement_company_code = item.settlement_company_code;
                        axios.get(this.$api_url+'/approver/mail-history', {
                            params: {
                                application_id: item.application_id
                            }
                        }).then(function(response) {
                    
                            if(response.data.length != 0)
                            {
                                this.mail_history = response.data;
                            }
                            
                        }.bind(this));

                        this.$bvModal.show('bv-modal-preview-settlement-email-history');
                    }
                }
                  
            },
            submit: function() {
                let currentObj = this;
                currentObj.showoverlaymodal = true;
                const selected_approvers = this.primary_selected
                    .filter(level => Array.isArray(level) && level.length > 0)
                    .flat();
                if(selected_approvers.length == 0) {
                    this.$bvToast.toast('Please select at least one approver', {
                        title: 'Error!',
                        variant: 'danger',
                        solid: true
                    });
                    currentObj.showoverlaymodal = false;
                } else {
                    const employee_ids = selected_approvers.map(item => item.split('-')[1]);
                    this.added_settlement_ids = this.added_settlements.map(item => item.settlement_id);

                    let formData = new FormData();
                    formData.append('emloyee_ids', employee_ids);
                    formData.append('settlement_ids', this.added_settlement_ids);
                    formData.append('level', this.approval_level);

                    axios.post(this.$api_url+'/approver/send-mail', formData)
                    .then(function (response) 
                    {
                        if(response.data == true) {
                            this.$bvToast.toast('Email is sent to all selected approvals', {
                                title: 'Success!',
                                variant: 'success',
                                solid: true
                            });
                            currentObj.showoverlaymodal = false;
                            this.$bvModal.hide('bv-modal-preview-added-settlement');
                        }
                        
                    }.bind(this)).catch(function (error){currentObj.serverError(error);});
                }
            },
            updateApprovers : function()
            {   
                let l = this.approvers_depth;

                this.global_approvers = {};

                axios.get(this.$api_url+'/getallapprover?l='+l).then(function(response){
                        
                        this.global_approvers = response.data;
                        this.getApproverSequence();
                    }.bind(this)); 
            },

            getSettings : function()
            {                
                axios.get(this.$api_url+'/approver/settings?module=9' , {
                    params: {                        
                    }
                }).then(function(response){
                    
                    this.approvers_depth = response.data.depth;

                    this.level_details = response.data.level_details;

                    this.updateApprovers();

                }.bind(this));
            },
            getApproverSequence : function()
            {          
                this.show_list = false;      
                axios.get(this.$api_url+'/approver/getsequence?module=9' , {
                    params: {                        
                    }
                }).then(function(response){
                    
                    this.selected = response.data.approvers;
                    
                    this.primary_selected = response.data.primary_approvers;

                    let l = this.approvers_depth;
                    for(let i=1 ; i<=l ; i++)
                    {
                        if(this.selected[i] == null)
                            this.selected[i] = [];

                        if(this.primary_selected[i] == null)
                            this.primary_selected[i] = [];
                            
                    }

                    for (var x in this.selected)
                    {
                        if(this.selected[x] != null)
                        {
                            for(var y in this.selected[x])
                            {
                                var z = this.selected[x][y];
                                
                                this.findMe(z , x);
                            }
                        }
                    }

                    

                    for (var x in this.primary_selected)
                    {
                        if(this.primary_selected[x] != null)
                        {
                            for(var y in this.primary_selected[x])
                            {
                                var z = this.primary_selected[x][y];
                        
                            }
                        }
                    }

                    this.show_list = true;

                }.bind(this));
            },
            findMe(e , l)
            {
                let x = this.selected[l].includes(e);                
                this.global_approvers.forEach((value, index) => {
                    if(value != null)
                    {
                        if(index != l)
                        {
                            value[e]['disabled'] = x;
                        }
                    }                    
                });                    
            },
            addToList:function()
            {
                if(this.selected_settlements.length > 0) {
                    const added_items = this.custom_list.filter(item => {
                        return this.selected_settlements.includes(item.settlement_id);
                    });
                    
                    const first_approval_pending = added_items[0].approval_pending;
                    this.approval_level = parseInt(first_approval_pending.match(/\d+/)[0]);
                    const has_different_approval_pending = added_items.some(item => item.approval_pending != first_approval_pending)
                    
                    if(has_different_approval_pending) {
                        this.$bvToast.toast('Please select same approval level settlements', {
                            title: 'Error!',
                            variant: 'danger',
                            solid: true
                        });
                    } else {
                        this.added_settlements = added_items;
                        this.getSettings();
                        this.$bvModal.show('bv-modal-preview-added-settlement');
                    }
                }
            },
            deleteRow(settlement_id){
                this.added_settlements = this.added_settlements.filter(item => item.settlement_id !== settlement_id);
            },
            getSettlementList: function()
            {

                this.show_loader = true;
                let currentObj = this;                    
                let formData = new FormData();
                if(!this.checkNet()) return false;
                formData.append('list_type', 'all');
                axios.post(this.$api_url+'/pf/settlement/list', formData)
                .then(function (response) 
                {
                    let temp_settle_list;
                    /* Assingning the Options */  

                    currentObj.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    temp_settle_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(temp_settle_list.length > 0 )
                    {
                        temp_settle_list.forEach(element => {
                            let dop = []; 
                            dop = dop.concat([{ label: 'Email History' , value: 1 }]);
                            
                            element.actions = dop; 
                        }); 
                    }
                    else
                    {
                        currentObj.blankmsg = "No employee found";
                    }
                    
                    currentObj.custom_list = temp_settle_list;
                    currentObj.custom_list.forEach(element => {
                        if(element.approval_pending == '') {
                            element.locked = 1;
                        }
                    });
                    
                    currentObj.list_key = currentObj.list_key + 1;
                    currentObj.show_loader = false;                       
                    
                }.bind(this))
                .catch(function (error) 
                {
                    currentObj.show_loader = false;
                });
                
            },
            overviewReturn:function()
            {
                this.$validator.reset();
                this.getSettlementList();
            },
        },
        created: function(){
            this.getSettlementList();
        },
        computed: 
        {
            
        }
    }
</script>

<style scoped>
.approve-level-content {
    padding: 2% 2%;
}
</style>

<!-- End: Rejwan: 08-05-2025 Batch Mailing Feature -->